import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingComponent } from './certifications/components/landing.component'
import { InavlidLinkComponent } from './certifications/components/invalidlink.component';
import { Welcomeomponent } from './certifications/components/welcome.component';
import { CertificationComponent } from './certifications/components/certificationcreate.component';
import { DisclaimerComponent } from './certifications/components/disclaimer.component';
import { AuthGuard } from './shared/services/authguard.service';
import { ReviewCertificationComponent } from './certifications/components/review-certification.component';
import { ConfirmationComponent } from './certifications/components/confirmation.component';
import { ErrorPage } from './shared/component/errorPage.component';
import { NotFoundComponent } from './shared/component/notfound.component';
import { RouteResolver } from './certifications/services/routeresolver.resolver';

const APP_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'entry',
        //redirectTo: 'form',
        pathMatch: 'full'
    },
    {
        path: 'entry',
        component: LandingComponent,
    },
    {
        path: 'disclaimer',
        component: DisclaimerComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'review',
        component: ReviewCertificationComponent,
        canActivate: [AuthGuard],
        data: { page: 'review' },
        resolve: { data: RouteResolver },
    },
    {
        path: 'welcome',
        component: Welcomeomponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'form',
        component: CertificationComponent,
        canActivate: [AuthGuard],
        data: { page: 'form' },
        resolve: { data: RouteResolver },
    },
    {
        path: 'complete',
        component: ConfirmationComponent,
        canActivate: [AuthGuard]

    },

    {
        path: 'link',
        component: InavlidLinkComponent,
    },
    { path: 'error', component: ErrorPage },

    {
        path: '404',
        component: NotFoundComponent
    },
    { path: '**', redirectTo: '/404' }
];

export const routing = RouterModule.forRoot(APP_ROUTES, { useHash: true });
